const CLOSING_PUNCTUATION = /^[,.;:!?)}\]]/u;
const OPENING_PUNCTUATION = /[([{]$/u;

export const spliceDictationTranscript = (
  base: string,
  caret: number,
  transcript: string,
  maxLength?: number,
) => {
  const left = base.slice(0, caret);
  const right = base.slice(caret);
  const normalizedTranscript = /\s$/u.test(left) ? transcript.trimStart() : transcript;
  const available = maxLength === undefined ? Number.POSITIVE_INFINITY : maxLength - base.length;
  if (!normalizedTranscript || available <= 0) return { value: base, caret };

  const leftSpace =
    left &&
    !/\s$/u.test(left) &&
    !OPENING_PUNCTUATION.test(left) &&
    !/^\s/u.test(normalizedTranscript) &&
    !CLOSING_PUNCTUATION.test(normalizedTranscript)
      ? " "
      : "";
  let spoken = normalizedTranscript.slice(0, Math.max(0, available - leftSpace.length));
  let rightSpace = needsRightSpace(spoken, right) ? " " : "";
  if (leftSpace.length + spoken.length + rightSpace.length > available) {
    spoken = spoken.slice(0, Math.max(0, available - leftSpace.length - rightSpace.length));
    rightSpace = needsRightSpace(spoken, right) ? " " : "";
  }
  if (!spoken) return { value: base, caret };

  const insertion = leftSpace + spoken + rightSpace;
  return { value: left + insertion + right, caret: caret + leftSpace.length + spoken.length };
};

const needsRightSpace = (transcript: string, right: string) =>
  Boolean(
    transcript &&
    right &&
    !/\s$/u.test(transcript) &&
    !OPENING_PUNCTUATION.test(transcript) &&
    !/^\s/u.test(right) &&
    !CLOSING_PUNCTUATION.test(right),
  );
